var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "overlay",
          rawName: "v-overlay:[{value:isVisible,class:classes}]",
          value: _vm.hide,
          expression: "hide",
          arg: { value: _vm.isVisible, class: _vm.classes },
        },
      ],
      ref: "dialog-wrapper",
      class: _vm.$style["mds-dialog-wrapper"],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": _vm.$style["mds-dialog-enter-active"],
            "leave-active-class": _vm.$style["mds-dialog-leave-active"],
            "enter-class": _vm.$style["mds-dialog-enter"],
            "leave-to-class": _vm.$style["mds-dialog-leave-to"],
          },
        },
        [
          _vm.isVisible
            ? _c(
                "div",
                {
                  ref: "dialog",
                  class: [
                    _vm.$style["mds-dialog"],
                    _vm.widthClass,
                    _vm.sizeClass,
                  ],
                  attrs: {
                    tabindex: "-1",
                    role: "dialog",
                    "aria-hidden": !_vm.isVisible,
                  },
                },
                [
                  _vm.title
                    ? _c("div", {
                        class: _vm.$style["mds-dialog__title"],
                        domProps: { innerHTML: _vm._s(_vm.title) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.$style["mds-dialog__message"] },
                    [
                      _vm._t("default", function () {
                        return [_vm._v(_vm._s(_vm.text))]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("mds-dialog-supplemental-content"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.$style["mds-dialog__actions"] },
                    [
                      _vm._t("mds-dialog-actions-left"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: _vm.$style["mds-dialog__actions-right"] },
                        [
                          _vm._t("mds-dialog-actions-right", function () {
                            return [
                              _c(
                                "mds-button",
                                {
                                  attrs: {
                                    type: "button",
                                    variation: "secondary",
                                    size: _vm.size,
                                  },
                                  on: { click: _vm.hide },
                                },
                                [_vm._v("Dismiss")]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }